<template>
  <div
    class="group relative bg-white border border-gray-200 duration-200 rounded-lg flex flex-col overflow-hidden"
    :class="active && '!border-blue-600'"
  >
    <svg v-if="active" xmlns="http://www.w3.org/2000/svg" class="absolute z-10 left-0 top-0 ml-2 mt-2 h-7 w-7 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
    </svg>

    <div class="aspect-w-3 aspect-h-3 bg-gray-200 group-hover:opacity-75 sm:h-64 border-b border-gray-200">
      <img :src="src" :alt="name" class="w-full h-full object-center object-cover sm:w-full sm:h-full">
    </div>
    <div class="flex-1 p-4 space-y-2 flex flex-col">
      <h3 class="text-sm font-medium text-gray-900">
        <span target="_blank" class="hover:underline cursor-pointer">
          {{ name }}
        </span>
      </h3>
      <p class="text-sm text-gray-500 line-clamp-4">
        <span v-html="description"></span>
      </p>
      <div class="flex-1 flex flex-col justify-end">
        <p class="text-sm italic text-gray-500">{{ brand }}</p>
        <p class="text-base font-medium text-gray-900">€{{ price }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['id', 'name', 'description', 'brand', 'sku', 'price', 'src', 'active'],
}

</script>
